import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

export default () => {
  const presenter = useLocalStore(() => ({
    get hasStream() {
      return Entities.ActiveStream.hasStream;
    },

    get isMeInitiator() {
      return Entities.ActiveStream.stream?.initiatorId === Entities.usersStore.Me.id;
    },
  }));

  return presenter;
};
